<template>
  <svg class="vuestic-icon-vuestic" version="1.1" id="Camada_1" xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="220 0 204 408"
     xml:space="preserve">
    <g>
      <path class="st0" d="M633.84,271.94c-30.59,65.76-105.28,101.81-177.42,81.79c-28.02-7.78-53.02-23.32-72.29-44.93
				c-1.43-1.61-1.29-4.07,0.31-5.5c1.61-1.43,4.07-1.29,5.5,0.32c18.27,20.49,41.98,35.22,68.56,42.6
				c76.15,21.14,155.3-23.62,176.44-99.76c14.59-52.56-1.47-107.98-41.92-144.64c-1.59-1.45-1.71-3.91-0.27-5.5
				c1.44-1.59,3.91-1.71,5.5-0.27c42.64,38.65,59.58,97.08,44.19,152.5C640.19,256.7,637.29,264.51,633.84,271.94z" />
    </g>
    <g>
      <path class="st1" d="M680.27,315.92c-14.48,23.95-33.66,44.75-56.58,61.16c-1.75,1.25-4.18,0.85-5.44-0.9
				c-1.25-1.75-0.85-4.18,0.9-5.43c31.05-22.24,54.97-52.84,69.18-88.49c19.78-49.64,19.04-104.01-2.07-153.1
				c-21.11-49.09-60.08-87.01-109.72-106.79C504.98-6.14,422.32,9.39,365.95,61.94c-1.57,1.47-4.04,1.38-5.5-0.19
				c-1.47-1.57-1.38-4.04,0.19-5.51C419.2,1.65,505.08-14.49,579.42,15.13c51.57,20.55,92.06,59.95,113.99,110.95
				c21.94,51,22.7,107.49,2.15,159.06C691.29,295.87,686.17,306.16,680.27,315.92z" />
    </g>
    <g>
      <path class="st2"
        d="M661.04,284.99c-28.42,61.09-88.62,101.87-157.73,104.32c-2.15,0.08-3.95-1.6-4.03-3.75
				c-0.08-2.15,1.6-3.95,3.75-4.03c66.14-2.34,123.75-41.38,150.95-99.84c4.03-8.65,7.38-17.72,10-27.16
				c12.39-44.65,6.66-91.45-16.14-131.78s-59.95-69.37-104.6-81.77c-19.49-5.41-39.51-7.39-59.48-5.88
				c-2.14,0.16-4.01-1.44-4.18-3.59c-0.16-2.14,1.45-4.02,3.59-4.18c20.88-1.58,41.79,0.49,62.15,6.14
				c46.65,12.95,85.46,43.3,109.29,85.44c23.83,42.15,29.82,91.05,16.87,137.7C668.76,266.48,665.25,275.96,661.04,284.99z" />
    </g>
    <g>
      <path class="st3" d="M251.57,155.28v-27.06h90.37V152l-33.93,34.65c4.58,0.82,9.04,2.12,13.39,3.9c4.35,1.78,8.19,4.27,11.52,7.48
			c3.32,3.21,6.01,7.18,8.06,11.89c2.05,4.72,3.07,10.43,3.07,17.12c0,6.84-1.12,13.12-3.36,18.86c-2.24,5.74-5.44,10.73-9.6,14.97
			c-4.16,4.24-9.24,7.52-15.23,9.84c-6,2.32-12.68,3.49-20.06,3.49c-12.08,0-22.34-2.31-30.8-6.92
			c-8.46-4.61-15.54-10.63-21.26-18.07l20.21-20.73c4.58,5.61,9.37,9.87,14.4,12.81c5.02,2.94,10.97,4.41,17.83,4.41
			c5.59,0,10.14-1.57,13.63-4.7c3.49-3.14,5.24-7.43,5.24-12.89c0-6-2.26-10.56-6.77-13.7c-4.51-3.14-10.97-4.71-19.36-4.71h-12.2
			l-4.58-20.04l31.85-34.37H251.57z" />
      <path class="st3" d="M442.45,165.74c-2.16-1.78-4.26-3.38-6.29-4.82c-2.03-1.44-4.13-2.63-6.29-3.59
			c-2.16-0.96-4.45-1.71-6.86-2.25c-2.42-0.55-5.02-0.82-7.82-0.82c-4.19,0-7.85,0.86-10.97,2.58c-3.12,1.72-5.79,4.06-8.01,7.02
			c-2.23,2.96-3.97,6.5-5.24,10.62c-1.27,4.13-2.16,8.53-2.67,13.2c3.3-2.32,7.09-4.44,11.35-6.36c4.26-1.91,9.69-2.87,16.3-2.87
			c6.61,0,12.78,0.99,18.5,2.97c5.72,1.98,10.68,4.89,14.87,8.71c4.2,3.83,7.5,8.61,9.92,14.35c2.41,5.74,3.62,12.37,3.62,19.89
			c0,7.38-1.3,14.11-3.91,20.19c-2.61,6.09-6.17,11.35-10.68,15.79c-4.51,4.44-9.89,7.86-16.11,10.25
			c-6.23,2.39-12.97,3.59-20.21,3.59c-8.77,0-16.21-1.3-22.31-3.9c-6.1-2.59-11.51-6.42-16.21-11.48
			c-4.83-5.19-8.68-11.99-11.54-20.4c-2.86-8.4-4.29-19.79-4.29-34.14c0-11.07,1.17-21.39,3.53-30.96
			c2.35-9.57,5.94-17.87,10.77-24.91c4.83-7.04,10.93-12.57,18.31-16.61c7.37-4.03,16.02-6.05,25.93-6.05
			c4.58,0,8.77,0.34,12.59,1.02c3.81,0.68,7.37,1.69,10.68,3.05c3.3,1.36,6.48,3.02,9.53,4.99c3.05,1.97,6.04,4.17,8.96,6.62
			L442.45,165.74z M427.64,210.64c-4.15-3.96-9.86-5.95-17.14-5.95c-7.28,0-12.93,1.95-16.95,5.84c-4.02,3.9-6.03,8.92-6.03,15.07
			c0,6.29,2.07,11.45,6.22,15.48c4.15,4.03,9.86,6.05,17.14,6.05c7.28,0,12.92-1.98,16.94-5.95c4.02-3.96,6.03-9.09,6.03-15.38
			C433.87,219.66,431.79,214.61,427.64,210.64z" />
      <path class="st3" d="M590.52,229.09c-2.86,9.02-6.9,16.88-12.11,23.58c-5.21,6.7-11.48,11.96-18.78,15.79
			c-7.31,3.83-15.42,5.74-24.31,5.74c-8.9,0-17-1.88-24.31-5.64c-7.31-3.76-13.54-8.98-18.69-15.68
			c-5.15-6.7-9.12-14.52-11.92-23.47c-2.8-8.95-4.2-18.69-4.2-29.22c0-10.39,1.43-20.13,4.29-29.22
			c2.86-9.09,6.89-16.98,12.11-23.68c5.21-6.7,11.47-11.96,18.78-15.79c7.31-3.83,15.41-5.74,24.31-5.74c8.9,0,17,1.88,24.31,5.64
			c7.31,3.76,13.54,8.99,18.69,15.68c5.15,6.7,9.12,14.56,11.92,23.58c2.79,9.02,4.2,18.73,4.2,29.12
			C594.81,210.3,593.38,220.07,590.52,229.09z M562.58,181.94c-1.4-5.6-3.37-10.46-5.91-14.56c-2.55-4.1-5.63-7.31-9.25-9.64
			c-3.62-2.32-7.66-3.49-12.11-3.49c-4.45,0-8.46,1.13-12.01,3.38c-3.56,2.25-6.61,5.4-9.15,9.43c-2.55,4.03-4.48,8.85-5.82,14.45
			c-1.34,5.61-2,11.69-2,18.25c0,6.56,0.7,12.64,2.1,18.25c1.4,5.61,3.37,10.46,5.91,14.55c2.54,4.1,5.63,7.31,9.25,9.64
			c3.62,2.32,7.66,3.49,12.11,3.49c4.45,0,8.45-1.13,12.01-3.38c3.56-2.25,6.61-5.43,9.15-9.53c2.54-4.1,4.48-8.92,5.82-14.45
			c1.34-5.53,2-11.58,2-18.14S563.98,187.54,562.58,181.94z" />
    </g>
    <g>
      <path class="st3" d="M23.78,173.39c1.02,2.74,2.87,5.25,5.54,7.51c2.67,2.26,6.37,4.32,11.08,6.17c4.71,1.85,10.76,3.6,18.15,5.24
			c14.9,3.57,25.89,8.5,32.96,14.82c7.07,6.31,10.61,15.02,10.61,26.13c0,6.18-1.13,11.8-3.4,16.87c-2.26,5.08-5.39,9.4-9.36,12.96
			c-3.98,3.57-8.77,6.31-14.37,8.23c-5.61,1.91-11.72,2.88-18.34,2.88c-10.7,0-20.48-1.86-29.33-5.57
			c-8.85-3.71-17.29-9.46-25.32-17.23l9.36-11.92c7,6.85,14.07,11.95,21.21,15.3c7.13,3.36,15.35,5.04,24.65,5.04
			c9.04,0,16.27-2.27,21.69-6.79c5.41-4.52,8.12-10.49,8.12-17.9c0-3.43-0.51-6.48-1.53-9.15c-1.02-2.67-2.81-5.11-5.36-7.31
			c-2.56-2.19-6.1-4.18-10.63-5.97s-10.31-3.5-17.33-5.15c-7.66-1.78-14.33-3.84-20.01-6.17c-5.68-2.33-10.38-5.14-14.08-8.43
			c-3.7-3.29-6.45-7.13-8.23-11.52c-1.79-4.39-2.68-9.61-2.68-15.64c0-5.76,1.08-11.04,3.25-15.84c2.16-4.8,5.22-8.95,9.17-12.45
			c3.95-3.5,8.6-6.24,13.95-8.23c5.35-1.99,11.21-2.98,17.58-2.98c9.81,0,18.37,1.45,25.7,4.35c7.32,2.9,14.42,7.27,21.3,13.11
			l-8.79,12.53c-6.24-5.48-12.51-9.45-18.82-11.92c-6.31-2.47-12.9-3.7-19.78-3.7c-4.33,0-8.25,0.62-11.75,1.85
			c-3.51,1.24-6.5,2.88-8.98,4.94c-2.48,2.06-4.39,4.52-5.73,7.4c-1.34,2.88-2.01,5.97-2.01,9.26
			C22.25,167.56,22.76,170.64,23.78,173.39z" />
      <path class="st3" d="M224.98,194.7c-2.8,5.89-6.59,10.82-11.37,14.79c-4.78,3.97-10.35,6.95-16.72,8.94
			c-6.37,1.99-13.12,2.98-20.25,2.98h-32.48v50.74h-15.09v-143.8h50.06c7.51,0,14.36,1.06,20.54,3.19
			c6.18,2.12,11.46,5.13,15.86,9.04c4.39,3.9,7.77,8.7,10.13,14.38c2.35,5.68,3.53,12.09,3.53,19.21
			C229.18,181.96,227.78,188.81,224.98,194.7z M204.22,151.25c-6.58-5.27-15.3-7.91-26.15-7.91h-33.91v63.27h33.14
			c5.49,0,10.5-0.75,15.04-2.26c4.53-1.51,8.43-3.66,11.69-6.47c3.26-2.81,5.75-6.16,7.47-10.07c1.73-3.9,2.59-8.25,2.59-13.04
			C214.08,164.37,210.8,156.52,204.22,151.25z" />
    </g>

  </svg>
</template>
<script>
export default {
  name: 'sp360-brand',
}

</script>

<style lang="scss">
  .vuestic-icon-vuestic {
    display: inline-block;
    align-items: left;
    width: 129px;
    padding-right: 1em;

    .st0 {
      fill: #86EEAF;
    }

    .st1 {
      fill: #00C359;
    }

    .st2 {
      fill: #40E583;
    }

    .st3 {
      fill: #FFFFFF;
    }

    .st0 {
      fill: #4AE387;
    }
  }

</style>
